module.exports = __webpack_public_path__ + "static/media/aMoi.ca89f7c9.mp3";